import { render, staticRenderFns } from "./AgoraView.vue?vue&type=template&id=47be2b3c&scoped=true&"
import script from "./AgoraView.vue?vue&type=script&lang=ts&"
export * from "./AgoraView.vue?vue&type=script&lang=ts&"
import style0 from "./AgoraView.vue?vue&type=style&index=0&id=47be2b3c&lang=scss&scoped=true&"
import style1 from "./AgoraView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be2b3c",
  null
  
)

export default component.exports